import React, { Suspense } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';

// Pages
const LandingScreen = React.lazy(() => import('../components/LandingScreen'));
const Login = React.lazy(() => import('../components/authentication/login/Login'));
const Register = React.lazy(() => import('../components/authentication/register/Register'));
const About = React.lazy(() => import('../components/pages/about/About'));
const Profile = React.lazy(() => import('../components/pages/profile/Profile'));
const Favorites = React.lazy(() => import('../components/pages/favorites/Favorites'));
const Products = React.lazy(() => import('../components/pages/products/Products'));
const ProductDetails = React.lazy(() => import('../components/pages/product-details/ProductDetails'));
const Bags = React.lazy(() => import('../components/pages/products/bags/Bags'));
const Perfumes = React.lazy(() => import('../components/pages/products/perfumes/Perfumes'));
const Sneakers = React.lazy(() => import('../components/pages/products/sneakers/Sneakers'));
const WatchesBracelets = React.lazy(() => import('../components/pages/products/watches/WatchesBracelets'));
const MiniBags = React.lazy(() => import('../components/pages/products/bags/MiniBags'));
const HandBags = React.lazy(() => import('../components/pages/products/bags/HandBags'));
const BackBags = React.lazy(() => import('../components/pages/products/bags/BackBags'));
const Cart = React.lazy(() => import('../components/pages/cart/Cart'));
const Checkout = React.lazy(() => import('../components/pages/checkout/Checkout'));
const Contact = React.lazy(() => import('../components/pages/support/Contact'));
const FAQs = React.lazy(() => import('../components/pages/support/FAQs'));
const Support = React.lazy(() => import('../components/pages/support/Support'));
const Orders = React.lazy(() => import('../components/pages/orders/Orders'));

// Admin
const AdminProducts = React.lazy(() => import('../components/admin/products/Products'));
const AdminProductDetails = React.lazy(() => import('../components/admin/products/ProductDetails'));
const AdminAddItems = React.lazy(() => import('../components/admin/add/AddItems'));

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const App = () => {

  return (
    <HashRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route exact path="/" name="Landing Page" element={<LandingScreen />} />
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route exact path="/register" name="Register Page" element={<Register />} />
          <Route exact path="/about" name="About Page" element={<About />} />
          <Route exact path="/profile" name="Profile Page" element={<Profile />} />
          <Route exact path="/orders" name="Orders Page" element={<Orders />} />
          <Route exact path="/favorites" name="Favorites Page" element={<Favorites />} />
          <Route exact path="/products" name="Products Page" element={<Products />} />
          <Route exact path="/product-details/:id" name="Product Details Page" element={<ProductDetails />} />
          <Route exact path="/bags" name="Bags Page" element={<Bags />} />
          <Route exact path="/perfumes" name="Perfumes Page" element={<Perfumes />} />
          <Route exact path="/mini-bags" name="Mini Bags Page" element={<MiniBags />} />
          <Route exact path="/hand-bags" name="Hand Bags Page" element={<HandBags />} />
          <Route exact path="/back-bags" name="Back Bags Page" element={<BackBags />} />
          <Route exact path="/sneakers" name="Sneakers Page" element={<Sneakers />} />
          <Route exact path="/watches & bracelets" name="Watches & Bracelets Page" element={<WatchesBracelets />} />
          <Route exact path="/cart" name="Cart Page" element={<Cart />} />
          <Route exact path="/checkout" name="Checkout Page" element={<Checkout />} />
          <Route exact path="/contact" name="Products Page" element={<Contact />} />
          <Route exact path="/faqs" name="FAQs Page" element={<FAQs />} />
          <Route exact path="/support" name="Support Page" element={<Support />} />

          <Route exact path="/admin-products" name="Admin Products Page" element={<AdminProducts />} />
          <Route exact path="/admin-product-details/:id" name="Product Details Page" element={<AdminProductDetails />} />
          <Route exact path="/admin-add-items" name="Add Items Page" element={<AdminAddItems />} />

        </Routes>
      </Suspense>
    </HashRouter>
  );
};

export default App;
